import { Alchemy, Network } from 'alchemy-sdk'
import { getAlchemyNetwork } from '../utils/getAlchemyNetwork'

let network: Network = getAlchemyNetwork('optimism')

const settings = {
  apiKey: window.ALCHEMY_API_KEY,
  network
}

export const OptimismAlchemy = new Alchemy(settings)
